import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["category", "brand", "label"],
  _excluded2 = ["fo", "facets"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getUndefinedIfEmpty = toTest => {
  if (toTest && Array.isArray(toTest)) {
    const cleanArray = toTest.filter(entry => entry !== undefined);
    return cleanArray.length > 0 ? cleanArray : undefined;
  }

  // cast potentially undefined to object
  const testAsObject = Object.assign({}, toTest);
  return Object.keys(testAsObject).length > 0 ? toTest : undefined;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formatFacetParameters = facetOptions => {
  return Object.keys(facetOptions).reduce((params, key) => {
    if (!facetOptions[key]) {
      return params;
    }
    const facetValues = facetOptions[key];
    if (facetValues.length > 0) {
      // eslint-disable-next-line no-param-reassign
      params[`facets[${key}]`] = facetValues.join(',');
    }
    return params;
  }, {});
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mergeParams = (params, additionalParams = {}) => getUndefinedIfEmpty(_objectSpread(_objectSpread({}, params), additionalParams));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mergeFacets = (facets, additionalFacets) => {
  const mergedParams = [...facets, ...additionalFacets];
  // de-duplicated
  return getUndefinedIfEmpty(mergedParams.filter((item, index) => mergedParams.indexOf(item) === index));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mergeFoParams = (params, additionalQueryParams = {}) => mergeParams(params && params.fo || {}, additionalQueryParams && additionalQueryParams.fo || {});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mergeFacetByName = (name, params,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
additionalQueryParams = {}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => mergeFacets(params && params[name] || [], additionalQueryParams.facets && additionalQueryParams.facets[name] ? additionalQueryParams.facets[name] : []);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const prepareFacets = (params, additionalQueryParams = {}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _ref = additionalQueryParams.facets || {},
    {
      category,
      brand,
      label
    } = _ref,
    otherFacets = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, otherFacets), {}, {
    category: mergeFacetByName('category', params, additionalQueryParams),
    brand: mergeFacetByName('brand', params, additionalQueryParams),
    label: mergeFacetByName('label', params, additionalQueryParams)
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const buildQueryParams = params => {
  const {
    ids,
    language,
    additionalQueryParams,
    preferredIds
  } = params;
  const queryParams = {};
  const passThroughParams = ['search', 'order', 'sort', 'region', 'is_variant', 'campaign_id', 'event_id', 'high_performer'];
  passThroughParams.forEach(paramName => {
    // Check only for undefined and null to allow falsy values (like boolean 'false')
    if (params[paramName] !== undefined && params[paramName] !== null) {
      queryParams[paramName] = params[paramName];
    }
  });
  if (ids) {
    queryParams.ids = ids.replace(/ /g, '');
  }
  if (preferredIds) {
    queryParams.preferredIds = preferredIds.replace(/ /g, '');
  }
  if (language) {
    queryParams.lang = language;
  }

  // check for is_variant: in q param of additionalQueryParams params for
  // backwards compatibility
  let additionalQueryParamsContainsQisVariant = false;
  if (additionalQueryParams) {
    additionalQueryParamsContainsQisVariant = additionalQueryParams && additionalQueryParams.q ? additionalQueryParams.q.indexOf('is_variant') !== -1 : false;
    if (additionalQueryParamsContainsQisVariant === true) {
      queryParams.is_variant = /is_variant:\s?true/.test(additionalQueryParams.q);
    }
  }
  const mergedFoParams = mergeFoParams(params, additionalQueryParams);
  const mergedFacetsParams = prepareFacets(params, additionalQueryParams);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _ref2 = additionalQueryParams || {},
    {
      fo,
      facets
    } = _ref2,
    leftOverAdditionalQueryParams = _objectWithoutProperties(_ref2, _excluded2);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, queryParams), mergedFoParams && {
    fo: mergedFoParams
  }), getUndefinedIfEmpty(mergedFacetsParams) && formatFacetParameters(mergedFacetsParams)), leftOverAdditionalQueryParams);
};